import { money, fmtDate } from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";

const LABELS = { deposit: "Deposit", withdrawal: "Withdrawal", buy: "Buy", sell: "Sell", adjustment: "Adjustment" };
const isCredit = (t) => t.type === "deposit" || t.type === "sell" || (t.type === "adjustment" && t.amount > 0);
const details = (t) => t.asset_label ? `${t.quantity} × ${t.asset_label} @ ${money(t.price)}` : [t.method, t.note].filter(Boolean).join(" · ");
const Amount = ({ t, className = "" }) => (
  <span className={`font-mono ${isCredit(t) ? "text-emerald-400" : "text-slate-200"} ${className}`}>{isCredit(t) ? "+" : "−"}{money(Math.abs(t.amount))}</span>
);

export default function TransactionsTable({ items, showClient = false, testId = "transactions-table" }) {
  return (
    <div data-testid={testId}>
      <ul className="divide-y divide-line/60 md:hidden" data-testid={`${testId}-mobile`}>
        {items.map((t) => (
          <li key={t.id} className="py-4" data-testid={`tx-card-${t.id}`}>
            <div className="flex items-center justify-between gap-3 text-sm">
              <span className="min-w-0 truncate text-white">{LABELS[t.type] || t.type}{showClient && <span className="text-slate-500"> · {t.user_name}</span>}</span>
              <Amount t={t} className="shrink-0" />
            </div>
            {details(t) && <p className="mt-1 truncate text-xs text-slate-400">{details(t)}</p>}
            <div className="mt-2 flex items-center justify-between gap-3 text-xs text-slate-500">
              <span>{fmtDate(t.created_at)}</span>
              <StatusBadge status={t.status} />
            </div>
          </li>
        ))}
        {!items.length && <li className="py-10 text-center text-sm text-slate-500">No transactions yet.</li>}
      </ul>
      <div className="hidden overflow-x-auto md:block">
      <table className="w-full min-w-[640px] text-left text-sm">
        <thead>
          <tr className="border-b border-line text-slate-500">
            <th className="py-3 pr-4 font-medium">Date</th>
            {showClient && <th className="py-3 pr-4 font-medium">Client</th>}
            <th className="py-3 pr-4 font-medium">Type</th>
            <th className="py-3 pr-4 font-medium">Details</th>
            <th className="py-3 pr-4 text-right font-medium">Amount</th>
            <th className="py-3 text-right font-medium">Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id} className="border-b border-line/60 last:border-0" data-testid={`tx-row-${t.id}`}>
              <td className="py-4 pr-4 whitespace-nowrap text-slate-400">{fmtDate(t.created_at)}</td>
              {showClient && <td className="py-4 pr-4 text-slate-300">{t.user_name}</td>}
              <td className="py-4 pr-4 text-white">{LABELS[t.type] || t.type}</td>
              <td className="py-4 pr-4 text-slate-400">{details(t)}</td>
              <td className="py-4 pr-4 text-right"><Amount t={t} /></td>
              <td className="py-4 text-right"><StatusBadge status={t.status} /></td>
            </tr>
          ))}
          {!items.length && <tr><td colSpan={showClient ? 6 : 5} className="py-12 text-center text-slate-500">No transactions yet.</td></tr>}
        </tbody>
      </table>
      </div>
    </div>
  );
}
